var Link = ReactRouter.Link;
var RoutePath = require('../../../constants/routePath');

module.exports = React.createClass({
  render(){
    var {t} = this.props;
    return (
      <div className="well no-padding">
        <div className="smart-form client-form">
          <header>
            {t("Email Confirmation")}
          </header>

          <fieldset>
            <section>
              {t("An email message with the link to 'Reset password' page has been sent to your email address.")}
            </section>
            <section>
              {t("Please check your mail box. The message should arrive within a few seconds. If it doesn't, please check your spam or junk mail folder.")}
            </section>
            <section
              dangerouslySetInnerHTML={
                            {
                                "__html": t('Go back to <a href="%s">Login page</a> to sign in.', {
                                            context: 'security',
                                            escapeValue:false,
                                            postProcess: 'sprintf',
                                            sprintf: [RoutePath.ROUTE_LOGIN]
                                        })
                            }}
            />
          </fieldset>
        </div>
      </div>
    );
  }

});
